import icons from '../images/icons'

export const paymentMethodsDetails = {
  PAYPAL: {
    bankDataKey: 'paypalWithdrawData',
    defaultPaymentType: 'PAYPAL',
    editTrans: 'editPayPalAccount',
    icon: icons.PayPalIcon,
    infoKey: ['email'],
    name: 'PAYPAL',
    setupTrans: 'setUpPaypal',
  },
  TRANSFERWISE: {
    bankDataKey: 'transfer_wise_data',
    defaultPaymentType: 'TRANSFERWISE',
    editTrans: 'editBankAccount',
    icon: icons.BankIcon,
    infoKey: ['account_number', 'iban'],
    name: 'TRANSFERWISE',
    setupTrans: 'setUpBankAccount',
  },
}

export const { PAYPAL, TRANSFERWISE } = paymentMethodsDetails

const countryPaymentMethods = {
  'en-CA': [ TRANSFERWISE, PAYPAL ],
  'en-GB': [ TRANSFERWISE, PAYPAL ],
  'en-US': [ TRANSFERWISE, PAYPAL ],
  'fr-FR': [ TRANSFERWISE, PAYPAL ],
  'ja-JP': [ TRANSFERWISE, PAYPAL ],
}

export default countryPaymentMethods
